import React, { useState } from "react";
import { CategoriasTAble } from "../../tablas/CategoriasTAble";
import { CategoriasForm } from "../../forms/CategoriasForm";

export const Categorias = () => {
	const [viewOpt, setviewOpt] = useState("table"); //estatus de la vista
	const [idActivo, setidActivo] = useState(0); //estatus de la vista
	const [borradoRefresh, setborradoRefresh] = useState(false); //estatus de la vista

	const chageForm = (id = 0) => {
		setidActivo(id);
		viewOpt === "table" ? setviewOpt("form") : setviewOpt("table");
	};
	return (
		<>
			<div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
				<div className="d-block mb-4 mb-md-0">
					<h4>Categorias</h4>
				</div>
			</div>

			{viewOpt === "table" ? (
				<CategoriasTAble
					cambiosVista={chageForm}
					setborradoRefresh={setborradoRefresh}
					borradoRefresh={borradoRefresh}
				/>
			) : (
				<CategoriasForm cambiosVista={chageForm} idActivo={idActivo} />
			)}
		</>
	);
};
